module.exports = __webpack_public_path__ + "img/gingerman.d9e0be03.svg";